import React from 'react';
import Section from '../Section';
import { OVERVIEW } from '../content';
import styles from './InfoPanel.module.css';

export default function Overview() {
  return (
    <Section id="overview" title="インターン概要" eyebrow="OVERVIEW">
      <dl className={`${styles.panel} ${styles.rows}`}>
        {OVERVIEW.map(row => (
          <div key={row.label} className={styles.row}>
            <dt className={styles.label}>{row.label}</dt>
            <dd className={styles.value}>{row.value}</dd>
          </div>
        ))}
      </dl>
    </Section>
  );
}
